import {CanActivate, Router} from '@angular/router';
import {Injectable} from '@angular/core';
import {AuthenticationService} from '../shared/service/authentication.service';

@Injectable()
export class Authenticator implements CanActivate {
  constructor(private authenticationService: AuthenticationService,
              private router: Router) {}

  canActivate() {
    const user = this.authenticationService.getUserFromLocalStorage();
    if (user) {
      return true;
    }

    this.router.navigate(['/login']);
    return false;
  }
}



// WEBPACK FOOTER //
// /home/jenkins/workspace/production-argos-front/argos/src/app/core/authenticator.ts